import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import ForgotPasswordSlide from './Layout/ForgetPassword';
import Login from './Layout/Login';
import Protected from './Protected';

const App = () => {
    return (
        <Routes>
            <Route index element={<Login />} />
            <Route path="forgotpassword" element={<ForgotPasswordSlide />} />
            {AppRoutes.map((item, index) => (
                <Route
                    path={item.path}
                    key={`menus${index}`}
                    element={<Protected Component={item.element} />}
                />
            ))}
        </Routes>
    );
}
export default App;